module.exports = __webpack_public_path__ + "media/1.2b3f74d3.wav";